var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMasahatIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.478,
    height: 14.324,
    viewBox: "0 0 14.478 14.324",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10772",
    "data-name": "Group 10772",
    transform: "translate(0.113 0.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15781",
    "data-name": "Path 15781",
    d: "M13.05,0H0L13.05,13.19Z",
    transform: "translate(13.99 0.799) rotate(90)",
    fill: "none",
    stroke: "#29a19c",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_722",
    "data-name": "Ellipse 722",
    cx: 0.5,
    rx: 0.5,
    transform: "translate(0 14)",
    fill: "#29a19c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_723",
    "data-name": "Ellipse 723",
    transform: "translate(14 14)",
    fill: "#29a19c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_724",
    "data-name": "Ellipse 724",
    cy: 0.5,
    ry: 0.5,
    transform: "translate(14)",
    fill: "#29a19c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16480",
    "data-name": "Path 16480",
    d: "M2705.143,1293a2.67,2.67,0,0,1,.567,2.675",
    transform: "translate(-2701.744 -1281.825)",
    fill: "none",
    stroke: "#29a19c",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16481",
    "data-name": "Path 16481",
    d: "M2719.917,1296.308v-1.891h2.167",
    transform: "translate(-2708.341 -1282.458)",
    fill: "none",
    stroke: "#29a19c",
    strokeWidth: 0.75
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasahatIcon);
export default __webpack_public_path__ + "static/media/MasahatIcon.6a8d11839e68baeeec6cb74e8b9e4b25.svg";
export { ForwardRef as ReactComponent };